+function($, window, document) {
	'use strict';
	
	var $scope;
	
	var SocialLogin = function(element, options) {
		this.options = options;
		this.$element = $(element);
		
		this.initialize();
	};
	
	SocialLogin.DEFAULTS = {
		iconFacebookSelector: '.social-options .icons .facebook a',
		iconTwitterSelector: '.social-options .icons .twitter a',
		iconGoogleSelector: '.social-options .icons .google a',
		fbPermissions: 'public_profile, email',
		errorMessage: 'There is something error happened! Please try it again!'
	};
	
	SocialLogin.prototype.initialize = function() {
		$scope = this;
		
		this.initRedirect();
		
		this.initFacebookLogin();
		this.initTwitterLogin();
		this.initGoogleLogin();
	};
	
	SocialLogin.prototype.initRedirect = function() {
		var emailForm = this.$element.find('.email-option form'),
			hiddenUrl;
		
		this.redirectUrl = null;
		
		if (emailForm.length > 0) {
			hiddenUrl = emailForm.find('input[name="return_url"]');
			
			if (hiddenUrl.length > 0) {
				this.redirectUrl = hiddenUrl.val();
			}
		}
	};
	
	SocialLogin.prototype.initGoogleLogin = function() {
		this.$element.on('click', this.options.iconGoogleSelector, function(event) {
			event.preventDefault();
			
			gapi.auth.signIn({
				'clientid': '777265039519-qqurkdhu7hm7hr54atio84h5ou0rcbj1.apps.googleusercontent.com',
				'cookiepolicy': 'single_host_origin',
				'requestvisibleactions': 'http://schema.org/AddAction',
				'scope': 'https://www.googleapis.com/auth/plus.login',
				'callback': function(authResult) {
					if (authResult['status']['signed_in']) {
						$.publish('showajaxnotification.sn', 'PROCESSING..');
						
						gapi.client.load('plus', 'v1', function() {
							$scope.googleLogin();
						});
					} 
				}
			});
		
			return false;
		});
	}; 
	
	SocialLogin.prototype.initFacebookLogin = function() {
		this.$element.on('click', this.options.iconFacebookSelector, function(event) {
			event.preventDefault();
			
			 FB.login(function(response) {
				 $.publish('showajaxnotification.sn', 'PROCESSING..');
				 
				 if (response.authResponse) {
				     FB.api('/me', function(response) {
				    	 $scope.facebooLogin(response);
				     });
				 }else {
					 $.publish('hideajaxnotification.sn');
				 }
			 }, {scope: $scope.options.fbPermissions});
		
			return false;
		});
	};
	
	SocialLogin.prototype.initTwitterLogin = function() {
		this.$element.on('click', this.options.iconTwitterSelector, function(event) {
			var deffered,
				openedWin,
				width,
				height,
				left,
				top,
				opts,
				timer;
			
			event.preventDefault();
			
			$.publish('showajaxnotification.sn', 'PROCESSING..');
			
			deffered = $.get('/customer/get_twitter_authorize', {'return_url': $scope.redirectUrl});
			
			deffered.done(function(response) {
				if (response.success) {
					//create new window to show twitter authorize page
//					width  = 575;
//			        height = 400;
//			        left   = ($(window).width()  - width)  / 2,
//			        top    = ($(window).height() - height) / 2,
//			        opts   = 'status=1' +
//			                 ',width='  + width  +
//			                 ',height=' + height +
//			                 ',top='    + top    +
//			                 ',left='   + left;
//			        
//			        openedWin = window.open(response.auth_url, 'twitter', opts);
			        
			        //listen the close event of opened window
//			        timer = setInterval(function() { 
//			            if(openedWin.closed) {
//			                clearInterval(timer);
//			                
//			                window.location = response.redirect_url;
//			            }
//			        }, 1000);
			        
			        window.location = response.auth_url;
				}else {
					alert($scope.options.errorMessage);
				}
			});
			
			deffered.always(function() {
				$.publish('hideajaxnotification.sn');
			});
			
			return false;
		});
	};
	
	SocialLogin.prototype.facebooLogin = function(response) {
		var deffered = $.post('/customer/facebook_login', {
			'email': response.email, 
			'first_name': response.first_name,
			'last_name': response.last_name
		});

		deffered.done(function(response) {
			if (response.success) {
				if ($scope.redirectUrl) {
					window.location = $scope.redirectUrl;
				}else {
					window.location = response.url;
				}
			}else {
				alert($scope.options.errorMessage);
			}
		});
		
		deffered.always(function() {
			$.publish('hideajaxnotification.sn');
		});
	};
	
	SocialLogin.prototype.googleLogin = function() {
		gapi.client.plus.people.get({userId: 'me'}).execute(function(response) {
			var deffered,
				email;
			
			email = $scope.getGooglePrimaryEmail(response);
			
			deffered = $.post('/customer/google_login', {
				'email': email, 
				'first_name': response.name.givenName,
				'last_name': response.name.familyName,
				'gender': response.gender
			});
			
			deffered.done(function(result) {
				if (result.success) {
					if ($scope.redirectUrl) {
						window.location = $scope.redirectUrl;
					}else {
						window.location = result.url;
					}
				}else {
					alert($scope.options.errorMessage);
				}
			});
			
			deffered.always(function() {
				$.publish('hideajaxnotification.sn');
			});
		});
	};
	
	SocialLogin.prototype.getGooglePrimaryEmail = function(resp) {
	    var primaryEmail;
	    
	    for (var i = 0; i < resp.emails.length; i++) {
	      if (resp.emails[i].type === 'account') {
	    	  primaryEmail = resp.emails[i].value;
	    	  break;
	      }
	    }
	    
	    return primaryEmail;
	};
	
	function Plugin(option) {
	    return this.each(function () {
    		var $this   = $(this),
    			data    = $this.data('sn.SocialLogin'),
    			options = $.extend({}, SocialLogin.DEFAULTS, typeof option == 'object' && option);
	      
	      if ( ! data) {
	    	  $this.data('sn.SocialLogin', (data = new SocialLogin(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      } 
	    });
	}
	
	var old = $.fn.Dialog;
	
	$.fn.SocialLogin = Plugin;
	$.fn.SocialLogin.Constructor = SocialLogin;
	
	$.fn.SocialLogin.noConflict = function () {
	    $.fn.SocialLogin = old;
	    return this;
	};
	
	//DATA-API
	$('[data-toggle="social-login"]').each(function () {
		var $element = $(this);
	  
		Plugin.call($element, $element.data())
	});
}(jQuery, window, document);